import { FormControlLabel, Switch } from "@mui/material";
import { useContext } from "react";
import { ThemeContext } from "../../Shared/Theme/ThemeContext";

//Toggles light/dark mode for application
export default function DarkModeSetting() {

    const { mode, setMode } = useContext(ThemeContext);

    function swapMode(event){
        event.preventDefault()
        if (mode === 'dark') setMode('light')
        else setMode('dark')
    }

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={mode === "dark"}
                    onClick={(event) => swapMode(event)}
                />
            }
            label="Dark Mode"
        />
    );
}
